export enum ViewTypeName {
    Active = 0,
    Archive = 1,
    Processing = 2,
    Error = 3,
  }
